<template>
    <div>
        <b-card no-body>
            <div>
                
                <div class="row">
                    <div class="col-10">
                        <div class="h6 text-titulo">
                            {{pegarTitulo(form.mensagem)}}
                        </div>
                        <b-badge>{{form.tipo}}</b-badge>
                    </div>
                    <div class="col-2">
                        <b-button variant="danger" @click="excluirAlerta" style="float:right">
                            <i class="fas fa-trash mr-2"></i>
                            Excluir alerta
                        </b-button>
                    </div>
                </div>
                <hr>
                <br/>
                <span v-html="form.mensagem" />
            </div>
        </b-card>
    </div>
</template>
<script>
import AlertaService from '@/common/services/alerta/alerta.service';
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { AlertasMixin } from '@/common/mixins/AlertasMixin';
export default {
    props : ['id'],
    mixins : [AlertasMixin],
    data : () => ({
        form : {}
    }),
    methods : {
        buscarAlerta : function(){
            AlertaService.buscar(this.id).then(response => {
                this.form = response.data.data;
            });
        },
        pegarTitulo : function(mensagem){
            var html = document.createElement('div');
            html.innerHTML = mensagem;
            let titulo = html.getElementsByClassName('titulo-vue');    

            if(titulo.length == 0){
                return "";
            }
            
            return titulo[0].innerHTML.replace(/<\/?[^>]+(>|$)/g, "");
        },
        pegarCorpo : function(mensagem){
            var html = document.createElement('div');
            html.innerHTML = mensagem;
            let corpo = html.getElementsByClassName('corpo')[0].innerHTML;    
            
            return corpo.replace(/<\/?[^>]+(>|$)/g, "");
        },

        visualizarAlerta : function(){
            AlertaService.visualizar(this.id).finally(() => {
                this.$store.dispatch("app/buscarAlertas");
            });
        },

        excluirAlerta : function(){
            this.confirmar("Deseja excluir o alerta?").then(confirmado => {
                if(!confirmado){
                    return;
                }

                AlertaService.remover(this.id).then(() => {
                    this.alertaSucesso("Alerta excluído com sucesso!").then(() => {
                        this.$router.push({ name : 'alertas' });
                    });
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else{
                        this.alertaErro("Ocorreu um erro ao excluir o alerta");
                    }  
                }).finally(() => {
                    this.$store.dispatch("app/buscarAlertas");
                });
            });
        }
    },
    mounted(){
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Alertas", to : "/alertas"},
            {titulo : "Mensagem"},
        ]);

        this.visualizarAlerta();

        this.buscarAlerta();
    },
    computed : {
        usuario : function(){
            return this.$store.state.app.userInfo;
        }
    }
}
</script>
<style>
    .corpo{
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        display: inline-block;
    }

    .borda-lateral{
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
</style>